import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pwa from './en-US/pwa';
import common from './en-US/common';
import form from './en-US/form';
import supportChat from './en-US/supportChat';
import notifications from './en-US/notifications';
import processes from '../pages/Process/locales/en-US';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page for your local project',
  'app.welcome.link.fetch-blocks': 'Get all blocks',
  'app.welcome.link.block-list': 'Quickly build standard pages based on block development',
  ...globalHeader,
  ...menu,
  ...pwa,
  ...component,
  ...common,
  ...form,
  ...supportChat,
  ...notifications,
  ...processes,
};
